import React, {useState} from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkIcon from '@material-ui/icons/Link';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

// share button
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
// copy to clip board

import {CopyToClipboard} from 'react-copy-to-clipboard';

import './NewsDetail.css';

function NewsDetail() {
  const [copied, setCopied] = useState('');
  const copiedToClipBoard = () => {
    setCopied('copied');
    setTimeout(() => setCopied(''), 5000);
  };

  return (
    <div className="main newsDetail">
      <div className="container newsDetail__container">
        <article>
          <div className="newsDetail__row">
            <div className="newsDetail__col">
              <img
                width="1920"
                height="1080"
                src="https://i.ytimg.com/vi/25nAvBYAlxU/maxresdefault.jpg"
                className="img-responsive news-img"
                alt="Katepilla by Bruce Melody"
              />{' '}
              <ul className="newsDetail__share">
                <li>
                  <span className="share-title">Share</span>
                </li>
                <li className="share__icon">
                  {' '}
                  <FacebookShareButton url="https://youtu.be/AyoJotEuxpI">
                    <FacebookIcon />
                  </FacebookShareButton>
                </li>
                <li className="share__icon">
                  <TwitterShareButton url="https://youtu.be/AyoJotEuxpI">
                    <TwitterIcon />
                  </TwitterShareButton>
                </li>
                <li className="share__icon">
                  <WhatsappShareButton url="https://youtu.be/AyoJotEuxpI">
                    <WhatsAppIcon />
                  </WhatsappShareButton>
                </li>
                <li className="share__icon">
                  <CopyToClipboard
                    text="https://youtu.be/AyoJotEuxpI"
                    onCopy={copiedToClipBoard}
                  >
                    <LinkIcon />
                  </CopyToClipboard>
                  <small style={{color: 'green'}}>{copied && copied}</small>
                </li>
              </ul>
            </div>
            <div className="newsDetail__col">
              <header>
                <time
                  pubdate=""
                  datetime="2021-05-13T11:48:09-05:00"
                  className="date"
                >
                  May 13 2021
                </time>
                <h1 className="news-title">
                BRUCE MELODY LATEST MUSIC IS OUT NOW IS CALLED KATEPILLA
                </h1>
              </header>

              <p>
              Bruce Melody bring the heat in their new official video
                    for “Katepilla”! Check out the video below., directed by&nbsp;
                <strong>MEDDY SALEH.</strong>
              </p>

              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/25nAvBYAlxU"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>

              <p></p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
}

export default NewsDetail;
